import { Col, List, Row, Switch } from "antd";
import overviewImg from "../../../../assets/staticImages/templateDetail.png";
import styles from "./Details.module.css";
import {
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import Modal from "../../../../components/modal/Modal";
import { MdDelete } from "react-icons/md";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { roles } from "../../../../config/roles";
import {
  CalendarIcon,
  ClockIcon,
  LocIcon,
  UserIcon,
} from "../../../../components/icons/Icons";
import brideImg from "../../../../assets/staticImages/bride.png";
import groomImg from "../../../../assets/staticImages/groom.png";
import {
  dummyMembers,
  TickSvg,
  EmptySvg,
} from "../../VendorTemplates/MyTemplates/MyTemplates";
import bubblesImg from "../../../../assets/bubbles.png";
import dummyImg from '../../../../assets/imageplace.jpg'
import moment from "moment";
const myTemplateDetails = [
  {
    title: "DJ Arrival Time:",
    icon: <CalendarIcon size={30} />,
    value: "09:30  Pm ",
  },
  { title: "Start Time:", icon: <ClockIcon size={30} />, value: "10:15 am" },
  { title: "End Time:", icon: <ClockIcon size={30} />, value: "02:15 pm" },
  { title: "Ceremony", icon: <UserIcon size={30} />, value: "" },
  {
    title: "Location:",
    icon: <LocIcon size={30} />,
    value: "Los Angeles, California",
  },
];



const personArr = [
  {
    title: "Bride",
    name: "Lucy Mark",
    img: brideImg,
    contact: "+1 (234) 456-4567",
  },
  {
    title: "Groom",
    name: "David Elson",
    img: groomImg,
    contact: "+1 (234) 456-4567",
  },
];

const LeftCol = ({ publicTemplate, item, eventData }) => {

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [personModalOpen, setPersonModalOpen] = useState(false);
  const [currentPerson, setCurrentPerson] = useState(personArr[0]);
  const [publicSwitch, setPublicSwitch] = useState(false);
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.imageContainer}>
        <img src={eventData?.image ? eventData?.image : dummyImg } alt="overviewImg" style={{ width: "100%" }} />
      </div>
      {publicTemplate ? (
        <>
          <Row className={styles.titleContainer}>
            <Col xs={24}>
              <TextComponent textClass={styles.publicTextGreen}>
                {eventData?.status}
              </TextComponent>
            </Col>
            <Col xs={24}>
              <TextComponent textClass={styles.overviewTitle}>
                {eventData?.name ? eventData?.name : "--"}
              </TextComponent>
            </Col>
          </Row>
          {/* <Row>
            <Col xs={24}>
              <SubmitButton
                title="Add To My Template"
                onClick={() => navigate("/templates/vendor")}
              />
            </Col>
          </Row> */}
        </>
      ) : (
        <>
          <Row className={styles.titleContainer}>
            <Col xs={16}>
              <TextComponent textClass={styles.overviewTitle}>
                Engagement Ceremony
              </TextComponent>
            </Col>
            <Col xs={8}>
              <Row gutter={8}>
                <Col>
                  <TextComponent textClass={styles.publicText}>
                    Public
                  </TextComponent>
                </Col>
                <Col>
                  <Switch
                    checked={publicSwitch}
                    onChange={setPublicSwitch}
                    style={{
                      backgroundColor: publicSwitch && "var(--primary-color)",
                    }}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className={styles.personImageContainer}>
            {personArr.map((person) => (
              <Col style={{ position: "relative" }}>
                <div className={styles.personImageWrapper}>
                  <div
                    className={styles.personImage}
                    style={{ backgroundImage: `url(${person.img})` }}
                  ></div>
                  <img src={bubblesImg} className={styles.bubblesImg} />
                </div>
                <TextComponent textClass={styles.personName}>
                  {person.title}
                </TextComponent>
                <TextComponent
                  textClass={styles.personDetails}
                  onClick={() => {
                    setCurrentPerson(person);
                    setPersonModalOpen(true);
                  }}
                >
                  View Details
                </TextComponent>
              </Col>
            ))}
          </Row>
        </>
      )}
      <Modal
        isModalOpen={deleteModalOpen}
        setIsModalOpen={setDeleteModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          <Col xs={24}>
            <Row justify={"center"}>
              <MdDelete className={styles.deleteIcon} />
            </Row>
            <div>
              <TextComponent textClass={styles.modalText1}>
                Do you want to Delete
              </TextComponent>
              <TextComponent textClass={styles.modalText2}>Event</TextComponent>
            </div>
          </Col>
          <div className={styles.modalBtnContainer}>
            <SubmitButton title="Delete" btnClass={styles.modalBtn} />
            <SubmitButton
              title="Cancel"
              outline={true}
              btnClass={styles.modalBtn}
              onClick={() => setDeleteModalOpen(false)}
            />
          </div>
        </Row>
      </Modal>
      <Modal
        isModalOpen={personModalOpen}
        setIsModalOpen={setPersonModalOpen}
        closable={true}
        className={styles.personModalContent}
      >
        {/* <Row className={styles.modalContent}> */}
        <Row style={{ alignItems: "center" }}>
          <Col xs={16} sm={18}>
            <TextComponent textClass={styles.modalPersonTitle}>
              {currentPerson.title}
            </TextComponent>
            <TextComponent textClass={styles.modalPersonName}>
              {currentPerson.name}
            </TextComponent>
            <TextComponent>k.r.mastrangelo@outlook.com</TextComponent>
          </Col>
          <Col xs={8} sm={6}>
            <div className={styles.personImageWrapper}>
              <div
                className={styles.personImage}
                style={{ backgroundImage: `url(${currentPerson.img})` }}
              ></div>
              <img src={bubblesImg} className={styles.bubblesImg} />
            </div>
          </Col>
        </Row>
        <Row gutter={[8, 8]} className={styles.modalDetails}>
          <Col xs={24}>
            <Row className={styles.modalDetailRow}>
              <Col xs={24} sm={11}>
                <Row className={styles.modalIconTextRow} align={"middle"}>
                  <LocIcon size={30} />
                  <TextComponent textClass={styles.modalIconText}>
                    Location:
                  </TextComponent>
                </Row>
              </Col>
              <Col xs={{ span: 24, offset: 4 }} sm={{ span: 12, offset: 1 }}>
                <TextComponent textClass={styles.modalDetailText}>
                  Los Angeles, California
                </TextComponent>
              </Col>
            </Row>
          </Col>
          <Col xs={24}>
            <Row className={styles.modalDetailRow}>
              <Col xs={24} sm={11}>
                <Row className={styles.modalIconTextRow}>
                  <UserIcon size={30} />
                  <TextComponent textClass={styles.modalIconText}>
                    Contact:
                  </TextComponent>
                </Row>
              </Col>
              <Col xs={{ span: 24, offset: 4 }} sm={{ span: 12, offset: 1 }}>
                <TextComponent textClass={styles.modalDetailText}>
                  {currentPerson.contact}
                </TextComponent>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* </Row> */}
        <Row className={styles.modalBtnContainer}>
          <SubmitButton
            title="Chat"
            btnClass={styles.modalBtn}
            onClick={() => navigate("/inbox")}
          />
        </Row>
      </Modal>
    </>
  );
};

const RightCol = ({ publicTemplate, item, eventData }) => {
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [members, setMembers] = useState(dummyMembers);
  const navigate = useNavigate();
  const publicTemplateDetails = [
    { title: eventData?.category?.name ? eventData?.category?.name : "--", icon: <UserIcon size={30} />, value: "" },
    {
      title: "Location:",
      icon: <LocIcon size={30} />,
      value: eventData?.address  ? eventData?.address : "--",
    },
    {
      title: "Date",
      icon: <CalendarIcon size={30} />,
      value: moment(eventData?.start_time).format("MMM DD YYYY"),
    },
    { title: "Start Time:", icon: <ClockIcon size={30} />, value: moment(eventData?.start_time).format("HH:mm A") || "--" },
    { title: "End Time:", icon: <ClockIcon size={30} />, value: moment(eventData?.end_time).format("HH:mm A") || "--" },
    { title: "Created By:", icon: <UserIcon size={30} />, value: eventData?.client_name || "--" },
   
   
  ];
  const details = publicTemplate ? publicTemplateDetails : myTemplateDetails;
 
  const selectMembers = (id) => {
    setMembers((prev) =>
      prev.map((member) => {
        if (member.id === id) {
          return { ...member, selected: !member.selected };
        } else {
          return member;
        }
      })
    );
  };

  return (
    <>
      <Row className={styles.templateDetailsRow}>
        <div>
          {details.map((detail) => (
            <Row className={styles.detailRow}>
              <Col className={styles.leftDetailCol}>
                {detail.icon}
                <TextComponent textClass={styles.detailTitle}>
                  {detail.title}
                </TextComponent>
              </Col>
              {detail.value && (
                <Col className={styles.detailValue}>
                  <TextComponent>{detail.value}</TextComponent>
                </Col>
              )}
              {detail.link && (
                <Col className={styles.detailLink}>
                  <TextComponent>{detail.link}</TextComponent>
                </Col>
              )}
            </Row>
          ))}
        </div>
        <div>
          {!publicTemplate && (
            <Row gutter={[12, 16]}>
              <Col xs={24} sm={12} xl={8}>
                <SubmitButton
                  title="Share"
                  onClick={() => setShareModalOpen(true)}
                />
              </Col>
              <Col xs={24} sm={12} xl={8}>
                <SubmitButton
                  title="Delete"
                  outline={true}
                  onClick={() => setDeleteModalOpen(true)}
                />
              </Col>
            </Row>
          )}
        </div>
      </Row>
      <Modal
        isModalOpen={deleteModalOpen}
        setIsModalOpen={setDeleteModalOpen}
        closable={true}
        pinkBg={true}
      >
        <Row className={styles.modalContent}>
          <Col xs={24}>
            <Row justify={"center"}>
              <MdDelete className={styles.deleteIcon} />
            </Row>
            <div>
              <TextComponent textClass={styles.modalText1}>
                Are you sure?
              </TextComponent>
              <TextComponent textClass={styles.modalText2}>
                To Delete This Template
              </TextComponent>
            </div>
          </Col>
          <div className={styles.modalBtnContainer}>
            <SubmitButton title="Delete" btnClass={styles.modalBtn} />
            <SubmitButton
              title="Cancel"
              outline={true}
              btnClass={styles.modalBtn}
              onClick={() => setDeleteModalOpen(false)}
            />
          </div>
        </Row>
      </Modal>
      <Modal
        isModalOpen={shareModalOpen}
        setIsModalOpen={setShareModalOpen}
        closable={true}
        className={styles.modal}
      >
        <div className={styles.modalCon}>
          <TextComponent text={"Customers"} textClass={styles.modalHeading} />
          <div className={styles.modalSearchCon}>
            <SearchInput placeholder={"Search"} />
          </div>
          <List
            dataSource={members}
            className={styles.modalList}
            renderItem={(item, index) => (
              <Row key={index} className={styles.modalItem}>
                <div className={styles.modalMembersDetails}>
                  <img src={item?.image} />
                  <TextComponent
                    text={item?.name}
                    textClass={styles.modalMembersName}
                  />
                </div>
                <div
                  className={styles.crossIconDiv}
                  onClick={() => selectMembers(item.id)}
                >
                  {item.selected ? TickSvg : EmptySvg}
                </div>
              </Row>
            )}
          />
          <SubmitButton
            title="Share"
            btnClass={styles.modalBtnMembers}
            onClick={() => setShareModalOpen(false)}
          />
        </div>
      </Modal>
    </>
  );
};

const Details = () => {
  const {
    state: { publicTemplate, item, eventData },
  } = useLocation();
  // const state = useLocation();

  console.log("eventData", eventData);
  // console.log("item", item);
  return (
    <Row gutter={24} className={styles.overviewContainer}>
      <Col
        xs={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 8 }}
        xl={{ span: 7 }}
      >
        <LeftCol publicTemplate={publicTemplate} item={item} eventData={eventData} />
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 24 }}
        lg={{ span: 16 }}
        xl={{ span: 17 }}
      >
        <RightCol publicTemplate={publicTemplate} item={item} eventData={eventData}/>
      </Col>
    </Row>
  );
};

export default Details;
